import css from '../taskDescription.module.css'
import preview from './preview.png'
import taskDescriptionTexts from '../taskDescriptionTexts'

const ZeroTypeTaskDescription = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.image} style={{ backgroundImage: `url("${preview}")` }}>
        <div className={css.imageTaskTypeNumber}>
          <p style={{ fontSize: '24px', color: '#976153' }}>5</p>
        </div>
      </div>
      <p className={css.description}>{taskDescriptionTexts[4]}</p>
    </div>
  )
}

export default ZeroTypeTaskDescription
